"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var queryable_1 = require("./queryable");
var sitegroups_1 = require("./sitegroups");
var util_1 = require("../../utils/util");
var SiteUsers = (function (_super) {
    __extends(SiteUsers, _super);
    function SiteUsers(baseUrl, path) {
        if (path === void 0) { path = "siteusers"; }
        _super.call(this, baseUrl, path);
    }
    SiteUsers.prototype.getByEmail = function (email) {
        return new SiteUser(this, "getByEmail('" + email + "')");
    };
    SiteUsers.prototype.getById = function (id) {
        return new SiteUser(this, "getById(" + id + ")");
    };
    SiteUsers.prototype.getByLoginName = function (loginName) {
        var su = new SiteUser(this);
        su.concat("(@v)");
        su.query.add("@v", encodeURIComponent(loginName));
        return su;
    };
    SiteUsers.prototype.removeById = function (id) {
        var o = new SiteUsers(this, "removeById(" + id + ")");
        return o.post();
    };
    SiteUsers.prototype.removeByLoginName = function (loginName) {
        var o = new SiteUsers(this, "removeByLoginName(@v)");
        o.query.add("@v", encodeURIComponent(loginName));
        return o.post();
    };
    SiteUsers.prototype.add = function (loginName) {
        var _this = this;
        var postBody = JSON.stringify({ "__metadata": { "type": "SP.User" }, LoginName: loginName });
        return this.post({ body: postBody }).then(function (data) { return _this.getByLoginName(loginName); });
    };
    return SiteUsers;
}(queryable_1.QueryableCollection));
exports.SiteUsers = SiteUsers;
var SiteUser = (function (_super) {
    __extends(SiteUser, _super);
    function SiteUser(baseUrl, path) {
        _super.call(this, baseUrl, path);
    }
    Object.defineProperty(SiteUser.prototype, "groups", {
        get: function () {
            return new sitegroups_1.SiteGroups(this, "groups");
        },
        enumerable: true,
        configurable: true
    });
    SiteUser.prototype.update = function (properties) {
        var _this = this;
        var postBody = util_1.Util.extend({ "__metadata": { "type": "SP.User" } }, properties);
        return this.post({
            body: JSON.stringify(postBody),
            headers: {
                "X-HTTP-Method": "MERGE",
            },
        }).then(function (data) {
            return {
                data: data,
                user: _this,
            };
        });
    };
    SiteUser.prototype.delete = function () {
        return this.post({
            headers: {
                "X-HTTP-Method": "DELETE",
            },
        });
    };
    return SiteUser;
}(queryable_1.QueryableInstance));
exports.SiteUser = SiteUser;
